import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import { ExamGrid } from '../components/ExamGrid';
import { BITSATLogo, JEELogo, NEETLogo, NDALogo, VITEEELogo } from '../components/icons/ExamLogos';

export const HomePage = () => {
  const navigate = useNavigate();
  const { user } = useApp();

  const exams = [
    { id: 'nda', name: 'NDA', subtitle: 'Defence entrance exam', emblem: <NDALogo className="w-full h-full object-contain" />, status: 'active' },
    { id: 'jee-main', name: 'JEE Main', subtitle: 'Engineering entrance', emblem: <JEELogo className="w-full h-full object-contain" />, status: 'active' },
    { id: 'neet', name: 'NEET', subtitle: 'Medical entrance prep', emblem: <NEETLogo className="w-full h-full object-contain" />, status: 'active' },
    { id: 'bitsat', name: 'BITSAT', subtitle: 'Aptitude & reasoning', emblem: <BITSATLogo className="w-full h-full object-contain" />, status: 'active' },
    { id: 'viteee', name: 'VITEEE', subtitle: 'Vellore Institute entrance', emblem: <VITEEELogo className="w-full h-full object-contain" />, status: 'active' },
  ].map(exam => ({ ...exam, progress: 0, lastAttempt: 'N/A', avgAccuracy: 0, badges: [] }));

  const handleViewMockTests = (exam, mode) => {
    if (exam.status === 'coming-soon') return;
    if (exam.id === 'nda' && mode === 'mock-list') {
      navigate('/nda/mock-tests');
      return;
    }
    if (exam.id === 'jee-main' && mode === 'mock-list') {
      navigate('/jee-main/mock-tests');
      return;
    }
    if (exam.id === 'neet' && mode === 'mock-list') {
      navigate('/neet/mock-tests');
      return;
    }
    if (exam.id === 'bitsat' && mode === 'mock-list') {
      navigate('/exam/bitsat/mock-tests');
      return;
    }
    if (exam.id === 'nda') {
      navigate('/exam/nda');
      return;
    }
    if (exam.id === 'jee-main') {
      navigate('/exam/jee-main');
      return;
    }
    if (exam.id === 'neet') {
      navigate('/exam/neet');
      return;
    }
    if (exam.id === 'bitsat') {
      navigate('/exam/bitsat');
      return;
    }
    if (exam.id === 'viteee') {
      navigate('/exam/viteee');
      return;
    }
  };

  const handleSelectPracticeMode = (exam, mode) => {
    if (mode === 'adaptive') {
      navigate('/knowledge-sprint');
    } else if (exam.id === 'nda' && mode === 'chapter-wise') {
      navigate('/nda/chapter-wise');
    } else if (exam.id === 'nda' && mode === 'paper-wise') {
      navigate('/nda/paper-wise');
    } else if (exam.id === 'jee-main' && (mode === 'chapter-wise')) {
      navigate('/jee-main/chapter-wise');
    } else if (exam.id === 'jee-main' && (mode === 'paper-wise')) {
      navigate('/jee-main/paper-wise');
    } else if (exam.id === 'neet' && mode === 'chapter-wise') {
      navigate('/neet/chapter-wise');
    } else if (exam.id === 'neet' && mode === 'paper-wise') {
      navigate('/neet/paper-wise');
    } else if (exam.id === 'bitsat' && (mode === 'chapter-wise' || mode === 'paper-wise')) {
      navigate('/exam/bitsat');
    } else if (exam.id === 'viteee' && (mode === 'chapter-wise' || mode === 'paper-wise')) {
      navigate('/exam/viteee');
    } else {
      alert(`Mode "${mode}" for exam "${exam.name}" is coming soon!`);
    }
  };

  return (
    <div className="mb-8 pt-12 lg:pt-0 bg-white text-black dark:bg-gray-800 dark:text-white">
      <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-brand-primary">
        Forge mastery, one test at a time.
      </h1>
      <p className="mt-2 text-lg text-brand-text-secondary">
        Practice papers, chapter drills, adaptive mocks — tailored to you.
      </p>
      <ExamGrid 
        exams={exams} 
        onViewMockTests={handleViewMockTests} 
        onSelectPracticeMode={handleSelectPracticeMode} 
      />
    </div>
  );
};